import { render, staticRenderFns } from "./characters.vue?vue&type=template&id=d3ce6a32&scoped=true&"
import script from "./characters.vue?vue&type=script&lang=js&"
export * from "./characters.vue?vue&type=script&lang=js&"
import style0 from "./characters.vue?vue&type=style&index=0&id=d3ce6a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ce6a32",
  null
  
)

export default component.exports